import { LearnableWithProgress, TemplateName } from 'src/api/learningSessions/types';
import MemLearning from '@memrise/memlearning';
import { convertLearnablesWithProgressToMemLearning } from './conversion';

// @ts-ignore: TO-DO - fix ignore
class Repository implements MemLearning.com.memrise.learning.session.SessionRepository {
  constructor(
    // @ts-ignore: TO-DO - fix ignore
    private learnablesWithProgress: Collections.List<MemLearning.com.memrise.learning.models.LearnableWithProgress>,
  ) { }

  fetchContentStructureProgress(callback: (contentStructureProgress: MemLearning.com.memrise.learning.models.ContentStructureProgress) => void) {
    // This function only gets used for tracking purposes which, for the
    // time being, we do not do inside web_client. Consequently, we can
    // pass dud values of false here.
    // Implement the real `contentStructureProgress` value as part of WEBSITE-2015.
    const isCourseCompleted = false;
    const isLevelCompleted = false;
    callback(
      new MemLearning.com.memrise.learning.models.CourseContentStructureProgress(
        isCourseCompleted, isLevelCompleted
      )
    );
  }

  fetchLearnables(callback: (
    // @ts-ignore: TO-DO - fix ignore
    learnablesWithProgress: Collections.List<MemLearning.com.memrise.learning.models.LearnableWithProgress>,
  ) => void): void {
    return callback(this.learnablesWithProgress);
  }

  progress(_situationID: string): undefined {
    // Web client doesnt yet support situation tests
    return undefined;
  }

  // LearningEvent isnt exported by Memlearning
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveUpdatedProgress(_progress: MemLearning.com.memrise.learning.models.LearnableProgress, _learningEvent: any): void {
    // no-op: We get the updated progress from the test result instead
  }
}

export const makeRepository = (
  learnablesWithProgress: LearnableWithProgress[],
  forceTestType?: TemplateName | null,
) => {
  const memLearnablesWithProgress =
    convertLearnablesWithProgressToMemLearning(learnablesWithProgress, forceTestType);
  return new Repository(memLearnablesWithProgress);
};
